import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
//import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
// import { startOfMonth, subMonths } from "date-fns";
// import moment from "moment";

// import { stateDate } from "../../../../utils/formatDate";

const initialState: any = {
  inputValues: {
    id: 11111,
    type: { label: 'Основная', value: 'main' },
    name: 'Петр',
    surname: 'Иванов ',
    patronymic: 'Петрович',
    role: { label: 'Мерчендайзер', value: 'merchandiser' },
    phone: '999 888 77 66',
    fired: {
      fired: false,
    },
    blocked: true,
    recipient: {
      surname: 'Голубева',
      name: 'Анжела',
      patronymic: 'Петровна ',
      birthplace: 'Москва',
      gender: { label: 'Женский', value: 'female' },
    },
  },
  inputTest: { costPerHour: '0.00', type: '1' },
};

export const profileEmployeesSlice = createSlice({
  name: 'profileEmployees',
  initialState,
  reducers: {
    reducerInputValuesProfile: ( state: Draft<any>, action: PayloadAction<any> ) => {
      state.inputValues = action.payload;
    },
    reducerTest: (state: Draft<any>, action: PayloadAction<any>) => {
      state.inputTest = { ...state.inputTest, ...action.payload };
    },
  },
});

export const { reducerInputValuesProfile, reducerTest } = profileEmployeesSlice.actions;

export default profileEmployeesSlice.reducer;